import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILayout, layoutsManager } from '@inpart-io/padme-iap';

import { store } from '../index';
import { actions } from './actions';
import { getters } from './getters';
import { type ILayoutByClassName } from './types';

const LAYOUT_MODULE = 'layout';

const state: ILayoutByClassName = {
    layoutByClassName: new Map()
};

const dataObjectModule = getDataObjectsModule<ILayout>(layoutsManager, 5);

const LayoutModuleInstance = merge<unknown>(dataObjectModule, { state, actions, getters });
store.registerModule(LAYOUT_MODULE, LayoutModuleInstance);

export { LAYOUT_MODULE };
